import { render, staticRenderFns } from "./snapshot.vue?vue&type=template&id=6145057f&scoped=true&"
import script from "./snapshot.vue?vue&type=script&lang=ts&"
export * from "./snapshot.vue?vue&type=script&lang=ts&"
import style0 from "./snapshot.vue?vue&type=style&index=0&id=6145057f&prod&lang=scss&"
import style1 from "./snapshot.vue?vue&type=style&index=1&id=6145057f&prod&lang=scss&scoped=true&"
import style2 from "./snapshot.vue?vue&type=style&index=2&id=6145057f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6145057f",
  null
  
)

export default component.exports